module.exports = __webpack_public_path__ + "static/media/hero-image-desktop@1x.33cc8b5b.jpg";